"use client";

import Link from "next/link";
import Image from "next/image";

const Logo = () => {
  return (
    <Link
      href="/"
      aria-label="Servani Safety Nets home"
      className="group relative block h-[46px] w-[151px] shrink-0 transition duration-300 hover:-translate-y-0.5 sm:h-[52px] sm:w-[170px]"
    >
      <Image
        src="/servani-safety-nets-logo-navbar.webp"
        alt="Servani Safety Nets"
        width={720}
        height={220}
        sizes="(max-width: 639px) 151px, 170px"
        className="h-full w-full object-contain drop-shadow-[0_4px_10px_rgba(0,0,0,0.18)] transition duration-300 group-hover:scale-[1.02]"
        priority
      />
    </Link>
  );
};

export default Logo;
